module.exports = __webpack_public_path__ + "static/media/leptophyes_albovittata_001_Tag_Sekunde_2_und_8_APA.bfa87f22.mp3";